import { Box, Icon } from "@mui/material";
import React from "react";
import { Mensagem } from "./types";
import { Notification } from "../../apis/notification-center-service";

type VisualizacaoMensagemProps = {
  mensagem?: Notification | undefined;
};

const defaultProps: VisualizacaoMensagemProps = {
  mensagem: undefined,
};

const VisualizacaoMensagem: React.FC<VisualizacaoMensagemProps> = ({
  mensagem,
}) => {
  return (
    <Box className="box-msg">
      <div className="header-msg">
        <Icon className="icone-msg">{mensagem?.content?.data?.icon}</Icon>
        <div className="titulo-msg">{mensagem?.content?.title}</div>
      </div>
      <div className="texto-msg">{mensagem?.content.data.message}</div>
      <div className="data-msg">{mensagem?.createdAt}</div>
    </Box>
  );
};

VisualizacaoMensagem.defaultProps = defaultProps;

export default VisualizacaoMensagem;
